import React from 'react';
import PropTypes from 'prop-types';

const InternalLink = ({ text, hasComma, url = '' }) => (
  <span>
    <a className="internal-linking__links--link" href={url}>
      {text}
    </a>
    {hasComma ? ', ' : null}
  </span>
);

InternalLink.propTypes = {
  text: PropTypes.string.isRequired,
  hasComma: PropTypes.bool,
  url: PropTypes.string.isRequired
};

InternalLink.defaultProps = {
  hasComma: null
};

export default InternalLink;
